import { DisplayTone } from '../lib/status';

const TONE_CLASS: Record<DisplayTone, string> = {
  ok: 'badge badge-ok',
  warn: 'badge badge-warn',
  bad: 'badge badge-bad',
  neutral: 'badge badge-neutral',
};

export function Badge({ tone, children }: { tone: DisplayTone; children: React.ReactNode }) {
  return <span className={TONE_CLASS[tone]}>{children}</span>;
}
